import { Component, Inject, EventEmitter } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { FrontEndService } from "../../services/front-end.service";
import { StateService } from '@uirouter/angular';
import { DataService } from 'app/services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
})
export class SignupComponent {
    sendState="signup";
    name_error = false;
    title_error = false;
    password_error = false;
    confirm_password_error = false;
    username_error = false;
    name = "";
    title = "";
    mobile_number = "";
    password = "";
    confirm_password = "";
    username = "";
    errorMessage = "";
    path="app/users/register/";
    closeResult: string;
    fullScreenLoader = false;

    // Focus variables
    public  name_focus =  new EventEmitter<boolean>();
    public  username_focus =  new EventEmitter<boolean>();

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private user_management_service: UserManagementService,
        private stateService: StateService,
        public dataService: DataService,
        private translate: TranslateService,
        private front_end_service: FrontEndService
    ) { }

    onSubmit(user) {
        const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const regPassword = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        if( user.name.trim() === "" || user.name === undefined) {
            this.name= "";
            this.name_error = true;
            this.name_focus.emit(true);
            this.errorMessage = 'enter_your_name'
        } else if( user.username.trim() === "" || user.username === undefined) {
            this.hideAllErrors()
            this.username_error = true;
            this.username_focus.emit(true);
            this.username= "";
            this.errorMessage = 'enter_an_email_id'
        } else if( !regEmail.test(user.username)) {
            this.hideAllErrors()
            this.username_error = true;
            this.username_focus.emit(true);
            this.errorMessage = 'enter_a_valid_email_id';
        } else {
            user['title'] = this.title;
            if(user['title'] == 'null') {
                user['title'] = ''
            }
            this.hideAllErrors();
            this.fullScreenLoader = true;
            this.user_management_service.signup(user, (resp) => {
                this.fullScreenLoader = false;
                if (resp.status) {
                    this.front_end_service.addToast(
                        "Success",
                        "user_created_inactive",
                        "success"
                    );
                    this.stateService.go('login');
                }
            });
        }
    }

    hideAllErrors() {
        this.confirm_password_error = false;
        this.password_error = false;
        this.username_error = false;
        this.name_error = false;
        this.title_error = false;
    }
}
